import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { Frequency } from "../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { SourceType } from "../../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { PercentageOrMoney } from "../../../../../../Shared/PercentageOrMoney/PercentageOrMoney";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { ProductDetailsStore } from "../../../../../Stroes/Variable";
import { EWizardLinterHelper } from "../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { FrequencyArraysMap, FrequencyTypeArrays } from "../../Resource/Contents";
import { SectionHeader } from "../../SharedComponents";
import { AdviserChargesContents, AdviserChargesValidation, ChargeFromMap, ChargeFromTypes } from "../Resource/Contents";
interface IOACProps extends IProcessComponentProps {
    type: SubAccountType;
    existingAccount?: boolean;
}

interface IOACState {
    currentTotal?: number;
}

export class OAC extends ProcessComponent<IOACProps, IOACState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentTotal: null,
        };
        this.subscribeToStore(ProductDetailsStore, () => this.onProductDetailsChange());
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.readonly) {return;}
        const { data, onChange, type, existingAccount } = this.props;
        if (existingAccount && !this.state.currentTotal) {
            this.onProductDetailsChange();
        }
        const sourceType = SubAccountTypeHelper.isOnPlatformPension(type) ? SourceType.ProductCash : SourceType.WrapCash;
        if (data && data.OngoingAdviceCharge) {
            if (isNullOrEmpty(data?.OngoingAdviceCharge?.SourceType) || data?.OngoingAdviceCharge?.SourceType == 0) {
                this.onDataChange(onChange, { SourceType: sourceType }, data, "OngoingAdviceCharge");
            }
            if (isNullOrEmpty(data.OngoingAdviceCharge.Frequency)) {
                this.onDataChange(onChange, { Frequency: Frequency.Monthly }, data, "OngoingAdviceCharge");
            }
        }
    }

    onProductDetailsChange() {
        const result = ProductDetailsStore.getSubAccount(this.props.type);
        if (result) {
            this.setState({
                currentTotal: result.TotalValue?.Amount,
            });
        }
    }

    oacGiven(): boolean {
        const amount = this.props.data?.OngoingAdviceCharge?.Money;
        const percentage = this.props.data?.OngoingAdviceCharge?.Percentage;
        return percentage || (amount && amount.Amount && amount.Amount > 0);
    }

    renderAlert() {
        const percentage = this.getPercentageBasedOnAmountOrPercentage();
        const oac = this.props.data?.OngoingAdviceCharge;
        console.log("oac", oac);
        const alerts = [];
        if (percentage >= 10 && percentage < 100) {
            alerts.push(
                <Alert
                    alertType={AlertType.Warning}
                    message={`You have requested an adviser payment of ${percentage.toFixed(
                        2
                    )}%. Please continue if this is correct.`}
                />
            );
        }
        if (
            SubAccountTypeHelper.isOnPlatformPension(this.props.type) &&
            oac?.SourceType == SourceType.WrapCash &&
            this.oacGiven()
        ) {
            alerts.push(
                <Alert alertType={AlertType.Warning} message={AdviserChargesValidation.WrapCashOACWarningMessage} />
            );
        }
        if (!isNullOrEmpty(alerts)) {
            return alerts;
        }
    }

    getPercentageBasedOnAmountOrPercentage(): number {
        const oac = this.props.data?.OngoingAdviceCharge;
        let percentageValue = oac?.Percentage;
        if (this.props.existingAccount == true && oac && oac.Money && oac.Money.Amount > 0) {
            const total = this.state.currentTotal;
            percentageValue = total ? (oac.Money.Amount / total) * 100 : 0;
        }
        return percentageValue ? percentageValue : 0;
    }

    public render(): JSX.Element {
        const { data, onChange, type } = this.props;
        const oac = data?.OngoingAdviceCharge;
        return (
            <WizardLinter status={EWizardLinterStatus.PleaseCheck} enabled={EWizardLinterHelper.shouldDisplay(type)}>
                {SectionHeader(
                    AdviserChargesContents.OAC,
                    "Ongoing charges are taken in arrears depending on the frequency you’ve chosen to be paid, e.g. monthly."
                )}
                {this.renderAlert()}
                <fieldset>
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-4">
                            <PercentageOrMoney
                                label={"Annual rate"}
                                data={oac}
                                onChange={(changes) =>
                                    this.onDataChange(onChange, changes, data, "OngoingAdviceCharge")
                                }
                                onRef={(ref) => this.appendChild(ref)}
                                cssPercentageOrMoneyClasses="control-size-115"
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                            <SelectEditor
                                options={FrequencyTypeArrays}
                                getText={(v) => {
                                    if (v == Frequency.Yearly) {return "Annually";}
                                    return FrequencyArraysMap[v];
                                }}
                                required={this.oacGiven() ? "required" : null}
                                selected={oac?.Frequency}
                                label="Deduction frequency"
                                onChange={(v) =>
                                    this.onDataChange(onChange, { Frequency: v }, data, "OngoingAdviceCharge")
                                }
                            />
                        </div>
                    </div>
                </fieldset>

                {SubAccountTypeHelper.isOnPlatformPension(type) && (
                    <RadiosEditor
                        cssWrapper="rg-150 mb-24"
                        label={"Take the charge from:"}
                        options={ChargeFromTypes}
                        selected={data?.OngoingAdviceCharge?.SourceType}
                        getText={(o) => ChargeFromMap[o]}
                        onChange={(v) => this.onDataChange(onChange, { SourceType: v }, data, "OngoingAdviceCharge")}
                        required={this.oacGiven() ? "required" : null}
                    />
                )}
            </WizardLinter>
        );
    }
}
